import WbHttpClient from './wbhttpclient';

class MeetingServices {
  constructor() {
    this.WbHttpClient = new WbHttpClient();
  }

  saveMeetingObjective(params = {}) {
      return this.WbHttpClient.post('meeting/saveMeetingObjective', params)
  }

  saveMeetingWorkstream(params = {}) {
      return this.WbHttpClient.post('meeting/saveMeetingWs', params)
  }
  
  saveMeetingKR(params = {}) {
      return this.WbHttpClient.post('meeting/saveMeetingKR', params)
  }
  
  saveMeetingAI(params = {}) {
      return this.WbHttpClient.post('meeting/saveMeetingAI', params)
  }

  searchresults(url) {
      return this.WbHttpClient.get(`${url}`);
  }

  // Get templates already added to a meeting
  getTemplates(meetingId) {
      return this.WbHttpClient.get(`restapi/meetings/${meetingId}/templates`);
  }

  // Get all available templates based on user visibility
  getAvailableTemplates(meetingId, page = 1, limit = 10, search = '') {
      let url = `restapi/meetings/${meetingId}/templates?available=true&page=${page}&limit=${limit}`;
      if (search) {
          url += `&search=${encodeURIComponent(search)}`;
      }
      return this.WbHttpClient.get(url);
  }

  addTemplate(meetingId, templateId) {
      return this.WbHttpClient.post(`restapi/meetings/${meetingId}/templates`, { templateId });
  }

  removeTemplate(meetingId, templateId) {
      return this.WbHttpClient.delete(`restapi/meetings/${meetingId}/templates`, { templateId });
  }

  getReviewAnswers(meetingId) {
    return this.WbHttpClient.get(`restapi/meetings/${meetingId}/reviewAnswers`);
  }

  getReviewAnswersSummary(meetingId) {
    return this.WbHttpClient.get(`restapi/meetings/${meetingId}/reviewAnswers?summary=1`);
  }

  saveReviewAnswer(meetingId, questionId, answer) {
    return this.WbHttpClient.put(`restapi/meetings/${meetingId}/reviewAnswers`, { questionId, answer });
  }

  submitReviewAnswers(meetingId) {
    return this.WbHttpClient.post(`restapi/meetings/${meetingId}/reviewAnswers`);
  }
}

export default MeetingServices;